import { create } from 'zustand';
import { saveAs } from 'file-saver';
import { ApiUtils } from '@shared/utils';
import { CardsApi, type DownloadStatementsRequest } from '@shared/api';

interface UseDownloadStatementsStore {
  loadingIds: Set<string>;
  data: boolean | null;
  error: string | null;
  downloadStatements: (request: DownloadStatementsRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadStatementsStore = create<UseDownloadStatementsStore>((set) => ({
  loadingIds: new Set<string>(),
  data: null,
  error: null,

  downloadStatements: async (request, signal) => {
    try {
      set((state) => ({ loadingIds: new Set(state.loadingIds).add(request.id), data: null, error: null }));
      const result = await CardsApi.downloadStatements(request.id, signal);
      saveAs(result.data, request.name);
      set({ data: true });
    } catch (error) {
      set({ data: false, error: ApiUtils.getApiError(error) });
    } finally {
      set((state) => {
        const loadingIds = new Set(state.loadingIds);
        loadingIds.delete(request.id);
        return { loadingIds };
      });
    }
  },

  clear: () => set({ loadingIds: new Set<string>(), data: null, error: null }),
}));
